import { post } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

import { MENTIONS_MARK_AS_READ } from '@/lib/routes/apiEndpoints';

export const ALL = 'all';
export const CAPTION = 'caption';
export const COMMENT = 'comment';
export const TAG = 'tag';

export const MENTION_ICON = {
    [ALL]: 'mentions',
    [COMMENT]: 'conversations',
    [CAPTION]: 'list',
    [TAG]: 'content'
};

export const MENTIONS_FILTER_OPTIONS = [ALL, CAPTION, COMMENT, TAG];

export const markMentionsAsRead = async (
    setMarkAsReadState,
    mutateMentions,
    mentionType,
    SPID,
    ids = []
) => {
    setMarkAsReadState((prevState) => ({
        ...prevState,
        isSubmitting: true,
        error: null
    }));

    const queryParams = { select: 'all' };

    if (ids.length) {
        queryParams.select = 'list';
        queryParams.ids = ids;
    } else if (ALL !== mentionType) {
        queryParams.type = mentionType;
    }

    try {
        const response = await post(
            injectEndpointUrlParams(MENTIONS_MARK_AS_READ, { SPID }),
            queryParams
        );

        const getNewUnreadCount = (previousUnreadCount, idsLength) => {
            if (!idsLength) {
                // Equivalent to mark all as read
                return 0;
            }
            if ('string' === typeof previousUnreadCount) {
                // Count is like "100+"
                return previousUnreadCount;
            }

            return Math.max(0, previousUnreadCount - idsLength);
        };

        if (response?.data?.success) {
            await mutateMentions(
                (prevState) =>
                    prevState.map((page) => ({
                        ...page,
                        data: page.data.map((mention) =>
                            !ids.length || ids.includes(mention.id)
                                ? {
                                      ...mention,
                                      is_read: true
                                  }
                                : mention
                        ),
                        summary: {
                            ...page.summary,
                            unread_count: getNewUnreadCount(page.summary.unread_count, ids.length)
                        }
                    })),
                false
            );
            setMarkAsReadState((prevState) => ({
                ...prevState,
                isSubmitting: false,
                error: null
            }));
        } else {
            setMarkAsReadState((prevState) => ({
                ...prevState,
                isSubmitting: false,
                error: true
            }));
        }
    } catch (e) {
        setMarkAsReadState((prevState) => ({
            ...prevState,
            isSubmitting: false,
            error: true
        }));
    }
};

export const handleMentionReply = async (mentionId, mentionWithReply, mutateMentions) => {
    await mutateMentions(
        (prevState) =>
            prevState.map((page) => {
                if (!page?.data?.some(({ id }) => id === mentionId)) {
                    return page;
                }
                return {
                    ...page,
                    data: page.data.map((mention) => {
                        if (mentionId !== mention.id) {
                            return mention;
                        }

                        let previousReplies =
                            mention.comment?.data.reply || mention.media?.data.reply || [];

                        if (!Array.isArray(previousReplies)) {
                            previousReplies = [previousReplies];
                        }

                        if (mentionWithReply.comment?.data.reply) {
                            return {
                                ...mentionWithReply,
                                comment: {
                                    ...mentionWithReply.comment,
                                    data: {
                                        ...mentionWithReply.comment.data,
                                        reply: [
                                            ...previousReplies,
                                            mentionWithReply.comment.data.reply
                                        ]
                                    }
                                }
                            };
                        }

                        return {
                            ...mentionWithReply,
                            media: {
                                ...mentionWithReply.media,
                                data: {
                                    ...mentionWithReply.media.data,
                                    reply: [...previousReplies, mentionWithReply.media.data.reply]
                                }
                            }
                        };
                    })
                };
            }),
        false
    );
};
